import React, { useEffect, useState } from "react";
import {
  Layout,
  Button,
  Row,
  Typography,
  Card,
  Select,
  Form,
  Col,
  Table,
  Input,
  Popconfirm,
} from "antd";
import { FilterOutlined, PlusOutlined, CloseOutlined, EditOutlined } from "@ant-design/icons"
import NewEntityMappingForm from "./NewEntityMappingForm";
import LoanProducts from "../../../../config/data/loanProducts.json"


const { Text } = Typography;

export const RolesToLPForm = (props) => {
  const [showRoleAccessTable, setShowRoleAccessTable] = useState(false)
  const [showAddButton, setShowAddButton] = useState(false)
  const [showAddForm, setShowAddForm] = useState(false)
  const [formData, setFormData] = useState(null);
  const [dataSource, setDataSource] = useState([]);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);


  const onSelectStartDate = (date, dateString) => {
    setStartDate(dateString)
  }

  const onSelectEndDate = (date, dateString) => {
    setEndDate(dateString)
  }


  const onFinishForm = (values) => {
    setFormData(values);
  }

  const handleValuesChange = (changedValues, allValues) => {
    setFormData(allValues)
  }

  const onCancel =() => {
    setShowAddForm(false)
  }

  const HandleFilterClick = () => {
    setShowRoleAccessTable(true)
    setShowAddButton(true)
    setShowAddForm(false)
  }

  const HandleAddClick = () => {
    setShowAddForm(true)
    setShowAddButton(false)
  }

  const AddEntityMapping = () => {
    const randomNumber = parseInt(Math.random() * 10000)
    const newData = {
      key: randomNumber,
      role: formData.Role,
      loanProducts: formData.loanProducts,
      startDate: startDate,
      endDate: endDate
    }

    setDataSource(pre => {
      return [...pre, newData]
    })
  }

  const handleDelete = (record) => {
    setDataSource(pre => {
      return pre.filter(item => item.key !== record.key)
    });
  };

  const [form] = Form.useForm();

  const columns = [
    {
      title: "Role",
      dataIndex: "role"
    },
    {
      title: "Loan Products",
      dataIndex: "loanProducts"
    },
    {
      title: "Start Date",
      dataIndex: "startDate"
    },
    {
      title: "End Date",
      dataIndex: "endDate"
    },
    {
      title: 'Actions',
      dataIndex: 'actions',
      render: (_, record) =>
        dataSource.length >= 1 ? (
          <>
            {/* <EditOutlined style={{ color: "#92428B", fontSize: "15px", fontWeight: "bolder"}} /> */}
            <Popconfirm
              title="Sure to delete?"
              onConfirm={() => handleDelete(record)}
              okText="OK"
              cancelText="Cancel"
              okButtonProps={{
                style: {
                  backgroundColor: '#92428B',
                  color: 'white',
                  height: "15%",
                  boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)"
                }
              }}
              cancelButtonProps={{
                style: {
                  height: "15%",
                  backgroundColor: "white",
                  boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)"
                }
              }}
            >
              <CloseOutlined style={{ color: "#92428B", fontSize: "15px", fontWeight: "bolder", marginLeft:15}} />
            </Popconfirm>
          </>
        ) : null,
    },
  ]

  return (
    <Card style={{
      marginBottom: "2%",
      boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
    }}
      title={"Role access to Loan products"}>

      <Form layout="vertical"
        onFinish={onFinishForm}
        form={form}
        initialValues={formData}
        onValuesChange={handleValuesChange}
        style={{ margin: 30 }}>
        <Card style={{
          marginBottom: "2%",
          boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
        }}
        >
          <Row style={{ justifyContent: "space-between" }}>
            <Col span={6}>
              <Form.Item
                label={<Text strong>Role</Text>}
                name={"role"}>
                <Select
                  placeholder="Select Role"
                  showSearch
                  style={{ width: "30vh" }}
                  options={LoanProducts} />
              </Form.Item>
            </Col>

            <Col span={6}>
              <Form.Item
                label={<Text strong>Loan Products</Text>}
                name={"loanProduct"}>
                <Select
                  placeholder="Select Loan Products"
                  showSearch
                  style={{ width: "30vh" }}
                  options={LoanProducts} />
              </Form.Item>
            </Col>

            <Col span={6}>
              <Form.Item
                label={<Text hidden strong>Filter</Text>}
                name={"filter"}>
                <Button
                  onClick={HandleFilterClick}
                  type="primary"
                  icon={<FilterOutlined />}
                  style={{ backgroundColor: "#92428B", color: "white", width: "15vh", marginBottom: 20 }}
                >Filter</Button>
              </Form.Item>
            </Col>

            <Col span={6}>
              {showAddButton && <Form.Item
                label={<Text hidden strong>Add</Text>}
                name={"add"}>
                <Button
                  onClick={HandleAddClick}
                  type="primary"
                  icon={<PlusOutlined />}
                  style={{ backgroundColor: "#92428B", color: "white", width: "15vh", marginBottom: 20 }}
                >Add</Button>
              </Form.Item>}
            </Col>
          </Row>
        </Card>

        {showAddForm &&
          <NewEntityMappingForm
            name={"Role"}
            productLabel={"Loan Products"}
            productName={"loanProducts"}
            addEntityMapping={AddEntityMapping}
            onSelectStartDate={onSelectStartDate}
            onSelectEndDate={onSelectEndDate}
            formData={formData}
            onCancel={onCancel}
            setFormData={setFormData}/>}

        {showRoleAccessTable &&
          <Table
            columns={columns}
            dataSource={dataSource} />}
      </Form>
    </Card>

  );
}

